import { httpClient } from '../httpClient/httpClient';

export type AllowedAxis = 'X' | 'Y';

export interface MatrixNodeValue {
  id: number;
  matrixNodeId: number;
  identifier: string;
  name: string;
  displayOrder: number;
  archived: boolean;
}

export interface MatrixNode {
  id: number;
  organizationId: number;
  name: string;
  valueMinLength: number | null;
  valueMaxLength: number | null;
  displayOrder: number;
  archived: boolean;
  allowedAxis: AllowedAxis;
  matrixNodeValues: MatrixNodeValue[];
}

export interface MatrixNodeRequest {
  name: string;
  valueMinLength: number | null;
  valueMaxLength: number | null;
  displayOrder: number;
  allowedAxis: AllowedAxis;
  archived: boolean;
  hasValueMinLength: boolean;
  hasValueMaxLength: boolean;
  matrixNodeValues: MatrixNodeValue[];
}

export interface MatrixGroupValue {
  id: number;
  name?: string;
}

export interface MatrixGroup {
  id: number;
  organizationId: number;
  name: string;
  matrixNodeId: number;
  displayOrder: number;
  matrixNodeValues: MatrixGroupValue[];
}

export interface MatrixGroupRequest {
  name: string;
  matrixNodeId: number;
  displayOrder: number;
  matrixNodeValues: MatrixGroupValue[];
}

export const matrixConfigurationApi = {
  getNodes: (organizationId: number) =>
    httpClient.get<MatrixNode[]>(`organizations/${organizationId}/matrixnodes`),
  createNode: (organizationId: number, request: MatrixNodeRequest) =>
    httpClient.post<MatrixNode>(`organizations/${organizationId}/matrixnodes`, {
      data: request,
    }),
  updateNode: (id: number, request: MatrixNodeRequest) =>
    httpClient.put<MatrixNode>(`matrixnodes/${id}`, { data: request }),
  getGroups: (organizationId: number) =>
    httpClient.get<MatrixGroup[]>(
      `organizations/${organizationId}/matrixgroups`,
    ),
  getGroup: (id: number) => httpClient.get<MatrixGroup>(`matrixgroups/${id}`),
  createGroup: (organizationId: number, request: MatrixGroupRequest) =>
    httpClient.post<MatrixGroup>(
      `organizations/${organizationId}/matrixgroups`,
      { data: request },
    ),
  updateGroup: (id: number, request: MatrixGroupRequest) =>
    httpClient.put<MatrixGroup>(`matrixgroups/${id}`, { data: request }),
  deleteGroup: (id: number) => httpClient.delete(`matrixgroups/${id}`),
};
